import { render } from "./SideNavComponentProvider.vue?vue&type=template&id=b160f048&scoped=true"
import script from "./SideNavComponentProvider.vue?vue&type=script&lang=js"
export * from "./SideNavComponentProvider.vue?vue&type=script&lang=js"

import "./SideNavComponentProvider.vue?vue&type=style&index=0&id=b160f048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b160f048"]])

export default __exports__